import { SettingTaskAPI } from "../api";
import moment from 'moment'
export class SettingTask {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  get statusString() {
    let statusLabel = {
      draft: "รอส่ง",
      pending: "รออนุมัติ",
      rejected: "ไม่อนุมัติ",
      approved: "อนุมัติ"
    }
    return statusLabel[this.status]
  }
  get createdByFullName() {
    let res = "";
    if (this.createdBy) {
      res = `${this.createdBy.firstName} ${this.createdBy.lastName}`;
    }
    return res;
  }
  get updatedByFullName() {
    let res = "-";
    if (this.updatedBy) {
      res = `${this.updatedBy.firstName} ${this.updatedBy.lastName}`;
    }
    return res;
  }
  get createdAtDateFormat() {
    let res = "";
    if (this.createdAt) {
      res = `${moment(this.createdAt).format("DD-MM-YYYY")}`;
    }
    return res;
  }
  get updatedAtDateFormat() {
    let res = "-";
    if (this.updatedAt && this.updatedBy) {
      res = `${moment(this.updatedAt).format("DD-MM-YYYY")}`;
    }
    return res;
  }
  get typeName() {
    let res = ''
    let labels = {
      billing_setting: "ใบแจ้งหนี้",
      area_accounting_product: "ราคารายการบิล",
    }
    if (this.type) {
      res = labels[this.type]
    } else {
      res = "ใบแจ้งหนี้"
    }
    return res
  }
  get actionString() {
    let res = ''
    let actionLabels = {
      add: "เพิ่ม",
      edit: "แก้ไข",
      remove: "ลบ"
    }
    if (this.action) {
      res = actionLabels[this.action]
    }
    return res
  }
  get currentAccountingProductString() {
    let res = '-'
    let typeLabel = {
      monthly: "รายเดือน",
      quantity: "ต่อหน่วย",
      day_of_month: "รายวัน"
    }
    if (this.requestData.currentAccountingProduct) {
      res = `${this.requestData.currentAccountingProduct.name} ${this.requestData.currentPrice} ${this.requestData.currentAccountingProduct.unit} / ${typeLabel[this.requestData.currentType]}`
    }
    return res
  }
  get previousAccountingProductString() {
    let res = '-'
    let typeLabel = {
      monthly: "รายเดือน",
      quantity: "ต่อหน่วย",
      day_of_month: "รายวัน"
    }
    if (this.requestData.previousAccountingProduct) {
      res = `${this.requestData.previousAccountingProduct.name} ${this.requestData.previousPrice} ${this.requestData.previousAccountingProduct.unit} / ${typeLabel[this.requestData.previousType]}`
    }
    return res
  }
  get currentAccountingProduct() {
    let res = '-'
    if (this.requestData.currentAccountingProduct) {
      res = `${this.requestData.currentAccountingProduct.name}`
    }
    return res
  }
  get previousAccountingProduct() {
    let res = '-'
    if (this.requestData.previousAccountingProduct) {
      res = `${this.requestData.previousAccountingProduct.name}`
    }
    return res
  }
  get currentPrice() {
    return this.requestData.currentPrice 
  }
  get previousPrice() {
    return this.requestData.previousPrice
  }
  get currentOriginalDiscount() {
    return this.requestData.currentOriginalDiscount || 0
  }
  get previousOriginalDiscount() {
    return this.requestData.previousOriginalDiscount || 0
  }
  get currentDiscountType() {
    return this.requestData.currentDiscountType || 0
  }
  get previousDiscountType() {
    return this.requestData.previousDiscountType|| 0
  }
  get diffPrice() {
    let res = 0
    res = (this.currentPrice - this.currentOriginalDiscount) - (this.previousPrice - this.previousOriginalDiscount)
    return { number: res, class: res > 0 ? "text-green-500 bg-green-50" : res < 0 ? "text-red-500 bg-red-50" : '', text: res > 0 ? '+' + res : res }
  }
  get currentType() {
    let res = '-'
    let typeLabel = {
      monthly: "รายเดือน",
      quantity: "ต่อหน่วย",
      day_of_month: "รายวัน"
    }
    if (this.requestData.currentType) {
      res = `${typeLabel[this.requestData.currentType]}`
    }
    return res
  }
  get previousType() {
    let res = '-'
    let typeLabel = {
      monthly: "รายเดือน",
      quantity: "ต่อหน่วย",
      day_of_month: "รายวัน"
    }
    if (this.requestData.previousType) {
      res = `${typeLabel[this.requestData.previousType]}`
    }
    return res
  }
  static async getSettingTask(id) {
    const { data } = await SettingTaskAPI.getSettingTask(id);
    return new SettingTask(data.result);
  }
  static async getSettingTasksByMarketSmall(payload) {
    const { data } = await SettingTaskAPI.getSettingTasksByMarketSmall(payload);
    return data.result;
  }
  static async getSettingTasks(payload) {
    const { data } = await SettingTaskAPI.getSettingTasks(payload);
    return data.result.map(item => new SettingTask(item));
  }
  static async createSettingTask(payload) {
    const { data } = await SettingTaskAPI.createSettingTask(payload);
    data.result = new SettingTask(data.result);
    return data.result;
  }
  static async updateSettingTask(payload) {
    const { data } = await SettingTaskAPI.updateSettingTask(payload);
    data.result = new SettingTask(data.result)
    return data.result;
  }
  static async updateSettingTasks(payload) {
    const { data } = await SettingTaskAPI.updateSettingTasks(payload);
    data.result.map(item => new SettingTask(item));
    return data.result;
  }
  static async removeSettingTask(id) {
    const { data } = await SettingTaskAPI.removeSettingTask(id);
    return new SettingTask(data.result);
  }

}
